<template>
    <div>
        <div class="custom-container" style="position: relative">
            <feather-icon
                icon="XIcon"
                class="cursor-pointer close-search-icon remove-merge-item"
                @click.stop="removeAsset"/>

            <vx-card class="mb-base">
                <div class="vx-row">
                <div class="vx-col w-full sm:w-full md:w-7/12">
                    <h2>{{ this.asset.title }}</h2>

                    <div>{{ this.asset.description }}</div>
                </div>
                    <div class="vx-col w-full sm:w-full md:w-5/12 d-flex align-center">
                        <div class="asset-thumbnail-section">
                            <div class="asset-img-section">
                                <img :src="asset.thumbnail ? asset.thumbnail : $root.getDefaultThumbnail(asset.asset_type)"
                                     alt="content-img" class="responsive card-img-top">
                            </div>
                        </div>
                    </div>
                <vs-divider/>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div>
                            <div class="custom-inline-input" v-if="asset.keywords && asset.keywords.length > 0">
                                <div class="custom-label">
                                    Tags
                                </div>
                                <div class="custom-input">
                                    <vs-chip color="dark" v-for="(item, index) in asset.keywords" :key="index">
                                        {{ item }}
                                    </vs-chip>
                                </div>
                            </div>
                            <div class="custom-inline-input" v-if="asset.typeKeywords && asset.typeKeywords.length > 0">
                                <div class="custom-label">
                                    Is a type of...
                                </div>
                                <div class="custom-input">
                                    <vs-chip color="dark" v-for="(item, index) in asset.typeKeywords" :key="index">
                                        {{ item }}
                                    </vs-chip>
                                </div>
                            </div>
                            <div class="custom-inline-input" v-if="asset.partKeywords && asset.partKeywords.length > 0">
                                <div class="custom-label">
                                    Is part of...
                                </div>
                                <div class="custom-input">
                                    <vs-chip color="dark" v-for="(item, index) in asset.partKeywords" :key="index">
                                        {{ item }}
                                    </vs-chip>
                                </div>
                            </div>
                            <vx-input-group class="mb-4 custom-input-group" v-if="asset.subject">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Subject
                                    </div>
                                </template>
                                <div>
                                    <vs-input
                                        disabled="true"
                                        v-model="asset.subject"
                                    />
                                </div>
                            </vx-input-group>
                            <vx-input-group class="mb-4 custom-input-group" v-if="asset.asset_type">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Type
                                    </div>
                                </template>
                                <div>
                                    <vs-input
                                        disabled="true"
                                        v-model="asset.asset_type"
                                    />
                                </div>
                            </vx-input-group>
                            <template v-if="asset.asset_type === 'video'">
                                <vx-input-group class="mb-4 custom-input-group" v-if="asset.video_type">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Video type
                                        </div>
                                    </template>
                                    <div>
                                        <vs-input
                                            disabled="true"
                                            v-model="asset.video_type"
                                        />
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="mb-4 custom-input-group" v-if="asset.narrator">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Narrator
                                        </div>
                                    </template>
                                    <div>
                                        <vs-input
                                            disabled="true"
                                            v-model="asset.narrator"
                                        />
                                    </div>
                                </vx-input-group>
                            </template>
                        </div>
                    </div>

                </div>
            </vx-card>

            <div class="variations-section" v-if="asset.variants.length">
                <div class="dfaicjcsb mb-base">
                    <h3 style="padding-right: 30px">
                  <span class="d-flex relative" style="padding-right: 5px;margin-left: 10px">
                    Variations
                    <vx-tooltip
                        class="help-tip"
                        position="right"
                        text="Use variation to store slightly different take of the same asset. E.g. “High Poly Source”, “Low Poly Animated”, “Quiz version in Hindi”.">
                                <i class="material-icons notranslate"> help_outline </i>
                    </vx-tooltip>
                  </span>
                    </h3>
                </div>
                <div class="px-4">
                    <div class="vx-row py-4" style="display: flex; flex-wrap: nowrap; overflow-x: auto">
                        <div v-for="(item, index) in asset.variants" :key="index" class="vx-col w-3/4 flex-no-shrink">
                            <VariantItem
                                :editMode="false"
                                :item="item"
                                :asset="asset"
                                :index="index"
                            />
                        </div>
                    </div>
                </div>
            </div>


            <div class="vx-row">
                <div class="vx-col w-full sm:w-full"
                     v-if="asset.academic_metadata && asset.academic_metadata.length > 0">
                    <vx-card>
                        <div class="dfaicjcsb mb-base">
                            <h3>Academic metadata</h3>
                        </div>
                        <!--<div class="d-flex">-->
                        <!--<div style="padding-right: 15px; flex-grow: 1">-->
                        <!--<vx-input-group class="custom-input-group">-->
                        <!--<template slot="prepend">-->
                        <!--<div class="prepend-text bg-dark">-->
                        <!--Concept Code-->
                        <!--</div>-->
                        <!--</template>-->

                        <!--<div class="d-flex">-->
                        <!--<v-select name="concept" :options="conceptResults"-->
                        <!--label="label"-->
                        <!--@search="fetchOptions"-->
                        <!--@input="onConceptOptionClick"-->
                        <!--placeholder="Concept code"-->
                        <!--v-model="concept_id_search" >-->
                        <!--<template slot="option" slot-scope="option">-->
                        <!--<div style="white-space: normal; line-height: 1; padding: 5px 0">-->
                        <!--<b>{{option.code}}</b>: <span>{{option.title}}</span>-->
                        <!--</div>-->
                        <!--</template>-->
                        <!--<template #no-options="{ search, searching, loading }">-->
                        <!--{{search.length >=3 ? "No concepts found" : "Type at least 3 characters."}}-->
                        <!--</template>-->
                        <!--</v-select>-->
                        <!--<span class="text-danger text-sm validation-error" v-show="errors.has('concept_id')">{{ errors.first('concept_id') }}</span>-->
                        <!--<vx-tooltip-->
                        <!--class="help-tip"-->
                        <!--position="top"-->
                        <!--text="Embibe Knowledge Graph concept ID.">-->
                        <!--<i class="material-icons notranslate"> help_outline </i>-->
                        <!--</vx-tooltip>-->
                        <!--</div>-->
                        <!--</vx-input-group>-->
                        <!--</div>-->
                        <!--</div>-->
                        <table v-if="asset.academic_metadata && asset.academic_metadata.length > 0"
                               class="meta-table mt-3">
                            <thead>
                            <th>Concept</th>
                            <th>Grade</th>
                            <th>Subject</th>
                            <th>Chapter</th>
                            <th>Topic</th>
                            <th v-if="$store.state.user.role.name === 'Manager'" style="width: 1px;"></th>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in asset.academic_metadata" :key="index">
                                <td>
                                    <div>
                                        <input type="text"
                                               class="table-input"
                                               v-model="item.concept_id"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <input type="text"
                                               class="table-input"
                                               v-model="item.grade"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <input type="text"
                                               class="table-input"
                                               v-model="item.subject"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <input type="text"
                                               class="table-input"
                                               v-model="item.chapter"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <input type="text"
                                               class="table-input"
                                               v-model="item.topic"
                                        />
                                    </div>
                                </td>
                                <!--<td v-if="$store.state.user.role.name === 'Manager'" style="padding: 5px">-->
                                <!--<vs-button color="danger" type="gradient" class="action-metadata-btn"-->
                                <!--@click="deleteMeta(item)"-->
                                <!--&gt;-->
                                <!--<i translate="translate" class="material-icons notranslate"> clear </i>-->
                                <!--</vs-button>-->
                                <!--</td>-->
                            </tr>
                            </tbody>
                        </table>
                    </vx-card>
                </div>
                <div class="vx-col w-full sm:w-full">
                    <vx-card>
                        <h3 style="margin-bottom: 20px">Sourcing</h3>
                        <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                                <div class="prepend-text bg-dark">
                                    License Type
                                </div>
                            </template>

                            <div>
                                <v-select name="license_type" v-validate="'required'" :options="licenseTypes"
                                          v-model="asset.license_type" :reduce="item => item.name" label="name"/>
                                <span class="text-danger text-sm validation-error" v-show="errors.has('license_type')">{{ errors.first('license_type') }}</span>
                            </div>
                        </vx-input-group>
                        <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                                <div class="prepend-text bg-dark">
                                    Partner
                                </div>
                            </template>

                            <div>
                                <vs-input
                                    name="license_partner"
                                    placeholder="Vida Systems, Kompanion, Designmate, etc"
                                    v-model="asset.license_partner"
                                />
                                <span class="text-danger text-sm validation-error"
                                      v-show="errors.has('license_partner')">{{ errors.first('license_partner') }}</span>
                            </div>
                        </vx-input-group>
                        <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                                <div class="prepend-text bg-dark">
                                    Source
                                </div>
                            </template>

                            <div>
                                <vs-input
                                    name="license_url"
                                    placeholder="Link to Turbosquid, CGTrader, etc"
                                    v-model="asset.license_url"
                                />
                                <span class="text-danger text-sm validation-error" v-show="errors.has('license_url')">{{ errors.first('license_url') }}</span>

                            </div>
                        </vx-input-group>
                        <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                                <div class="prepend-text bg-dark">
                                    Attribution
                                </div>
                            </template>

                            <div>
                                <vs-input
                                    name="attribution"
                                    placeholder="For CC-BY content only, person or organization name to be credited"
                                    v-model="asset.attribution_text"
                                />
                                <span class="text-danger text-sm validation-error" v-show="errors.has('attribution')">{{ errors.first('attribution') }}</span>
                            </div>
                        </vx-input-group>
                        <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                                <div class="prepend-text bg-dark">
                                    Price
                                </div>
                            </template>

                            <div class="custom-input" style="display: flex">
                                <div class="w-full relative">
                                    <vs-input
                                        name="price"
                                        v-validate="'numeric'"
                                        class="price-input"
                                        placeholder="Price"
                                        v-model="asset.price"
                                    />
                                    <span class="text-danger text-sm validation-error" v-show="errors.has('price')">{{ errors.first('price') }}</span>
                                </div>
                            </div>
                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <vs-button
                                        color="primary"
                                        type="border"
                                        v-for="(c, i) in currencies"
                                        :key="i"
                                        @click="asset.currency = c.value"
                                        class="radiobtn"
                                        :class="{selected: asset.currency === c.value}">
                                        {{c.name}}
                                    </vs-button>
                                </div>
                            </template>
                        </vx-input-group>
                    </vx-card>
                </div>
            </div>

            <vx-card class="mb-base">
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-full">
                        <div style="padding-right: 30px;">
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Notes
                                    </div>
                                </template>

                                <div class="d-flex">
                                    <vs-textarea
                                        class="resize-vertical"
                                        name="name"
                                        placeholder="Write your notes..."
                                        v-model="asset.notes"
                                    />
                                    <vx-tooltip
                                        class="help-tip"
                                        position="right"
                                        text="Additional notes that might help with tracking the asset, such as Jira CAC numbers or special instructions">
                                        <i class="material-icons notranslate"> help_outline </i>
                                    </vx-tooltip>
                                </div>

                            </vx-input-group>
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Test
                                    </div>
                                </template>

                                <div class="d-flex">
                                    <div class="vx-input-group-append flex-grow">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                color="primary"
                                                type="border"
                                                @click="asset.is_test = true"
                                                class="radiobtn"
                                                :class="{selected: asset.is_test}">
                                                Yes
                                            </vs-button>
                                            <vs-button
                                                color="primary"
                                                type="border"
                                                @click="asset.is_test = false"
                                                class="radiobtn"
                                                :class="{selected: !asset.is_test}">
                                                No
                                            </vs-button>
                                        </div>
                                    </div>
                                    <span class="text-danger text-sm validation-error"
                                          v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                    <vx-tooltip
                                        class="help-tip"
                                        position="right"
                                        text="If Yes, the asset is considered a temporary testing asset that might be deleted at any time">
                                        <i class="material-icons notranslate"> help_outline </i>
                                    </vx-tooltip>
                                </div>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-col w-full sm:w-full md:w-1/3">

                    </div>
                </div>
            </vx-card>

            <vx-card v-if="asset.related_assets && asset.related_assets.length">
                <div class="dfaicjcsb mb-base">
                    <h3 style="padding-right: 30px">
                  <span class="d-flex relative" style="padding-right: 5px">
                    Related Assets
                    <vx-tooltip
                        class="help-tip"
                        position="right"
                        text="Other assets that are conceptually related to this asset.">
                                <i class="material-icons notranslate"> help_outline </i>
                    </vx-tooltip>
                  </span>
                    </h3>
                    <!--<vs-button color="primary" type="gradient" @click="isAddRelatedAsset = true"-->
                    <!--v-if="related_assets.length > 0">-->
                    <!--&lt;!&ndash;<i translate="translate" class="material-icons notranslate"> add </i>&ndash;&gt;-->
                    <!--Add related asset-->
                    <!--</vs-button>-->
                </div>
                <div class="vx-row">
                    <div class="vx-col related-item custom-asset-card mb-base w-full sm:w-1/2 md:w-1/3"
                         v-for="(item, index) in asset.related_assets"
                         :key="index">
                        <vx-card>
                            <div class="delete-icon-block" v-if="$store.state.user.role.name === 'Manager'">
                                <button type="button" class="btn-x-file"
                                        @click="deleteElement('related_assets', index)">
                                    <i translate="translate" class="material-icons notranslate"> clear </i>
                                </button>
                            </div>

                            <div slot="no-body" class="card-img-block">
                                <div class="asset-img-section">
                                    <img :src="item.thumbnail ? item.thumbnail : $root.getDefaultThumbnail(item.asset_type)"
                                         alt="content-img" class="responsive card-img-top">
                                </div>
                                <vs-chip
                                    :color="item.asset_type === 'video' ? 'danger' : item.asset_type === 'image' ? 'success' : 'primary'"
                                    class="item-category">{{ getTypeName(item) }}
                                </vs-chip>
                                <!--<vs-chip color="primary" class="item-type">{{ item.visual_style }}</vs-chip>-->
                            </div>
                            <h5 class="mb-2">{{ item.title }}</h5>
                            <p class="text-grey asset-desc">{{ item.description }}</p>
                        </vx-card>
                    </div>
                    <!--<div class="vx-col w-full custom-asset-card" v-if="related_assets.length == 0">-->
                    <!--<div-->
                    <!--style="display: flex; justify-content: center; align-items: center; height: 100%; min-height: 250px">-->
                    <!--<vs-button radius color="primary" type="filled" icon-pack="feather" icon="icon-plus"-->
                    <!--class="plus-btn" @click="isAddRelatedAsset = true"></vs-button>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </vx-card>

        </div>
        <error404 v-if="isError" :is_page="true"></error404>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import 'swiper/dist/css/swiper.min.css'
    import addRelatedAssets from '../components/modal/addRelatedAssets.vue'
    import addVariation from '../components/modal/addVariation.vue'
    import addMetaData from '../components/modal/addMetaData.vue'
    import customUpload from '../components/customUpload.vue'
    import VariantItem from '../components/VariantItem.vue'
    import info from '../components/modal/info.vue'
    import Error404 from './pages/Error404.vue'
    import {Validator} from 'vee-validate';
    import axios from 'axios'

    export default {
        name: 'ViewMergeAsset',
        components: {
            addRelatedAssets,
            addVariation,
            info,
            vSelect,
            VariantItem,
            customUpload,
            addMetaData,
            Error404
        },
        props: {
            asset: {
                type: Object,
                default: null
            },
        },
        head: {
            title() {
                return {
                    inner: 'AMP',
                    separator: this.header_separator,
                    complement: this.header_component
                }
            },
            meta: [
                {hid: 'description', name: 'description', content: ''}
            ]
        },
        data() {
            return {
                debounce: false,
                isUniqName: false,
                isError: false,
                isLoading: false,
                isChanged: false,
                isSaved: false,
                header_separator: ' ',
                header_component: '',
                isAddRelatedAsset: false,
                isAddVariation: false,
                isAddMetaData: false,
                isInfoModal: false,
                deleteItem: null,
                deleteItemType: null,
                editVariationItem: null,
                editMetadataItem: null,
                types: this.$store.state.types,
                licenseTypes: [
                    {
                        value: "CC0/Public Domain",
                        name: "CC0/Public Domain",
                    }, {
                        value: "CC-BY",
                        name: "CC-BY",
                    }, {
                        value: "CC-SA",
                        name: "CC-SA",
                    }, {
                        value: "CC-ND",
                        name: "CC-ND",
                    }, {
                        value: "Embibe Internal",
                        name: "Embibe Internal",
                    }, {
                        value: "Purchased",
                        name: "Purchased",
                    }, {
                        value: "Editorial Only",
                        name: "Editorial Only",
                    },
                ],
                currencies: [
                    {
                        value: "USD",
                        name: "USD",
                    }, {
                        value: "INR",
                        name: "INR",
                    },
                ],
                category: '',
                categories: [],
                subCategories: [],
                visualStyles: [],
                thumbnails: [],
                related_assets: [],
                uploadData: {},
                progressData: {
                    source: {},
                    ready: {}
                },
                concept_id_search: "",
                conceptResults: [],
                cDebounce: false,
                self: null
            }
        },
        mounted() {
            this.self = this;
        },
        methods: {
            removeAsset() {
                this.$emit('removeSelectedAsset', this.asset);
            },
            deleteMeta(item) {
                const deleteMeta = () => {
                    if (item.id !== "new") {
                        this.$root.addLoading('#edit-asset-update-btn');

                        this.$axios.delete('/academic-metadata/' + item._id)
                            .then(res => {
                                this.$root.removeLoading('#edit-asset-update-btn');
                            }).catch(e => {
                                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
                                this.$root.removeLoading('#edit-asset-update-btn');
                        })
                    }
                    this.asset.academic_metadata.splice(this.asset.academic_metadata.indexOf(item), 1);
                };
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Are you sure you want to delete this meta?`,
                    text: 'This is a permanent and irreversible action.',
                    accept: deleteMeta
                })
            },
            onConceptOptionClick(concept) {
                let newMeta = {
                    "new": true,
                    "concept_id": concept.code
                };
                if (this.asset._id) {
                    newMeta.asset = this.asset._id;
                }
                if (concept.kv_details && concept.kv_details.learning_map && concept.kv_details.learning_map.length) {
                    let m = concept.kv_details.learning_map[0];
                    newMeta.grade = m.grade || "";
                    newMeta.subject = m.subject || "";
                    newMeta.chapter = m.chapter || "";
                    newMeta.topic = m.topic || "";
                }
                this.conceptResults = [];
                this.concept_id_search = "";
                this.asset.academic_metadata.push(newMeta);
            },
            fetchOptions(search, loading) {
                if (search.length < 3) return;
                clearTimeout(this.cDebounce);
                this.cDebounce = setTimeout(() => {
                    this.conceptResults = [];
                    loading(true);
                    this.$axios.get(`/metaproxy/search/${search}`).then(res => {
                        if (res.data && res.data._items) {
                            this.conceptResults = res.data._items.map(c => Object.assign(c, {label: c.code + " " + c.title}));
                            loading(false);
                        }
                    }).catch(e => {
                        console.log('catch_search', e)
                        this.conceptResults = [];
                        loading(false);
                    })
                }, 500)
            },
            changeUploadImages(e) {
                this.$root.addLoading('#edit-asset-update-btn');
            },
            updateHead() {
                this.header_component = this.asset.title
                this.header_separator = '-'
                this.$emit('updateHead')
            },
            getAsset(assetId) {
                let id = assetId ? assetId : this.$route.params.id;
                if (id) {
                    let url = '/assets/' + id;

                    this.$axios.get(url).then(res => {
                        this.asset = res.data;
                        if (res.data.thumbnail && res.data.thumbnail.length > 0) {
                            this.thumbnails.push(res.data.thumbnail[0])
                        }
                        this.uploadData = {
                            ref: 'Asset',
                            refId: this.asset._id,
                            field: 'thumbnail'
                        };
                        if (this.asset.related_assets && this.asset.related_assets.length > 0) {
                            let related_assets = [];
                            for (let i in this.asset.related_assets) {
                                let url = '/assets/' + this.asset.related_assets[i];

                                this.$axios.get(url).then(res => {
                                    related_assets.push(res.data)
                                }).catch(e => {
                                    console.log('catch_search', e)
                                })
                            }

                            this.related_assets = related_assets;
                        }
                        if (this.asset.notes && this.asset.notes.length) {
                            this.asset.notes = this.asset.notes.replace(/&amp;#13;&amp;#10;|&#13;&#10;/g, "\n")
                            this.asset.notes = this.asset.notes.replace(/,+/g, ",")
                        }
                        this.updateHead();
                        if (this.$route.query.variation) {
                            let item = null;
                            for (let k in this.asset.variants) {
                                if (this.asset.variants[k]._id == this.$route.query.variation) {
                                    item = this.asset.variants[k];
                                    break;
                                }
                            }
                            if (item) {
                                this.editVariation(item)
                            }
                        }
                    }).catch(e => {
                        this.isError = true;
                        document.querySelector('.content-wrapper').classList.add('custom-content-wrapper')
                        console.log('catch_search', e)
                    })
                } else {
                    let res = {
                        "animated": true,
                        "asset_id": "",
                        "asset_type": "3D",
                        "attribution_text": "",
                        "category": "",
                        "description": "",
                        "keywords": [],
                        "license_partner": "",
                        "license_type": "Embibe Internal",
                        "license_url": "",
                        "price": "",
                        "currency": "USD",
                        "related_assets": [],
                        "sub-category": "",
                        "thumbnail": "",
                        "title": "",
                        "visual_style": "",
                        "variants": [],
                        "academic_metadata": [],
                        "is_test": true
                    };

                    this.asset = res;
                }
            },
            getCategories() {
                let url = '/categories';

                this.$axios.get(url).then(res => {
                    this.categories = res.data;
                }).catch(e => {
                    console.log('getCategories', e)
                })
            },
            getSubCategories() {
                let url = '/sub-categories';

                this.$axios.get(url).then(res => {
                    this.subCategories = res.data;
                }).catch(e => {
                    console.log('getCategories', e)
                })
            },
            getVisualStyles() {
                let url = '/visual-styles';

                this.$axios.get(url).then(res => {
                    this.visualStyles = res.data;
                }).catch(e => {
                    console.log('getCategories', e)
                })
            },
            download(links, item_index, type) {
                let id = '.download-' + type + '-' + item_index;
                this.$root.addLoading(id);

                this.$set(this.progressData[type], item_index, {
                    data: {}
                })

                let files = {};
                let promises = [];

                links.forEach((item, index) => {
                    let options = {
                        responseType: 'arraybuffer',
                        onDownloadProgress: (progressEvent) => {
                            const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                            if (totalLength !== null) {
                                this.$set(this.progressData[type][item_index].data, index, Math.round((progressEvent.loaded * 100) / totalLength))
                            }
                        },
                    };

                    let instance = axios.create();
                    delete instance.defaults.headers.common['Authorization'];

                    promises.push(instance.get(item.url, options).then(res => {
                        files[index] = res.data;
                    }).catch(e => {
                        console.log('download', e)

                        this.$root.removeLoading(id);
                    }))
                });

                Promise.all(promises).then((res) => {
                    this.$set(this.progressData[type][item_index], 'zip_data', {})

                    if (Object.keys(files).length == 1) {
                        const blob = new Blob([files[0]]);
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = links[0].name + links[0].ext;
                        link.click();
                        URL.revokeObjectURL(link.href);

                        this.$set(this.progressData[type][item_index].zip_data, links[0].name, 100)
                        setTimeout(() => {
                            this.progressData[type][item_index] = false;
                            setTimeout(() => {
                                this.$root.removeLoading(id);
                            }, 500)
                        }, 500)
                    } else {
                        let zip = new JSZip();
                        let zipData = {};
                        for (let k in files) {
                            let name = links[k].name + links[k].ext;

                            if (zip.files[name]) {
                                name = links[k].name + '_' + Math.random().toString(36).substring(5) + links[k].ext;
                            }

                            zip.file(name, files[k]);
                            zipData[name] = 0;
                        }


                        zip.generateAsync({
                            type: "blob",
                            compression: "DEFLATE",
                            compressionOptions: {
                                level: 1
                            }
                        }, (metadata) => {
                            if (metadata.currentFile) {
                                let data = Object.assign({}, this.progressData[type][item_index].zip_data);
                                data[metadata.currentFile] = metadata.percent;

                                this.$set(this.progressData[type][item_index], 'zip_data', data)
                            } else {
                                if (metadata.percent === 100) {
                                    let temp_key = null;
                                    for (let k in this.progressData[type][item_index].zip_data) {
                                        if (this.progressData[type][item_index].zip_data[k] !== 100) {
                                            temp_key = k;
                                            break;
                                        }
                                    }
                                    if (temp_key) {
                                        this.$set(this.progressData[type][item_index].zip_data, temp_key, 100)
                                    }
                                }

                            }
                        }).then((blob) => {
                            let n = {ready: "coobo", source: "source"}
                            saveAs(blob, `${this.asset.title}_${this.asset.variants[item_index].name}_${n[type]}.zip`);
                            setTimeout(() => {
                                this.progressData[type][item_index] = false;
                            }, 500)
                        }, (err) => {
                            console.log(err);

                            this.$root.removeLoading(id);
                        }).then(() => {
                            // let data = this.progressData[type][item_index];
                            // delete data[item_index];
                            //
                            setTimeout(() => {
                                this.$root.removeLoading(id);
                            }, 500)
                        });
                    }
                });
            },
            closeAddRelatedAssets(data) {
                if (data) {
                    let found = [];
                    if (this.asset.related_assets.length > 0) {
                        data.forEach(item => {
                            for (let i in this.asset.related_assets) {
                                if (this.asset.related_assets[i]._id == item.id) {
                                    found.push(item.id)
                                    this.asset.related_assets[i] = item;
                                    break;
                                }
                            }
                        })
                    }

                    if (!this.asset.related_assets) {
                        this.asset.related_assets = [];
                    }
                    data.forEach(item => {
                        if (this.asset.related_assets.indexOf(item._id) == -1) {
                            this.related_assets.push(item);
                            this.asset.related_assets.push(item._id);
                        }
                    })
                }
                this.isAddRelatedAsset = false;
            },
            closeAddVariation(data) {
                if (data) {
                    let found = false;
                    for (let i in this.asset.variants) {
                        if (this.asset.variants[i]._id == data.item._id) {
                            found = true;
                            this.asset.variants[i] = data.item;
                            break;
                        }
                    }
                    if (!found) {
                        this.asset.variants.push(data.item);
                    }
                }
                this.editVariationItem = null;
                this.isAddVariation = false;
            },
            closeAddMetaData(data) {
                if (data) {
                    let found = false;
                    for (let i in this.asset.academic_metadata) {
                        if (this.asset.academic_metadata[i]._id == data._id) {
                            found = true;
                            this.asset.academic_metadata[i] = data;
                            break;
                        }
                    }
                    if (!found) {
                        this.asset.academic_metadata.push(data);
                    }
                }
                this.editMetadata = null;
                this.isAddMetaData = false;
            },
            closeInfoModal(data) {
                if (data) {
                    if (this.deleteItemType !== 'related_assets') {
                        this.$root.addLoading('#edit-asset-update-btn');

                        let url = '/';
                        if (this.deleteItemType == 'academic_metadata') {
                            url += 'academic-metadata'
                        } else {
                            url += 'variants'
                        }

                        url += '/' + this.asset[this.deleteItemType][this.deleteItem].id

                        this.$axios.delete(url)
                            .then(res => {
                                this.$root.removeLoading('#edit-asset-update-btn');

                                this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Successfully deleted'})
                            }).catch(e => {
                          this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
                          this.$root.removeLoading('#edit-asset-update-btn');
                        })
                    }

                    this.asset[this.deleteItemType].splice(this.deleteItem, 1);
                    if (this[this.deleteItemType]) {
                        this[this.deleteItemType].splice(this.deleteItem, 1);
                    }
                }

                this.deleteItem = null;
                this.deleteItemType = null;
                this.isInfoModal = false;
            },
            viewVariation(item, index) {
                this.isSaved = true;

                this.$router.push("/" + this.asset._id + '/' + item._id)
            },
            editVariation(item, index) {
                this.editVariationItem = item;
                this.isAddVariation = true;
            },
            deleteElement(type, index) {
                this.deleteItem = index;
                this.deleteItemType = type;
                this.isInfoModal = true;
            },
            deleteAsset() {
                const deleteAsset = () => {
                    this.$axios.delete('/assets/' + this.$route.params.id).finally(() => {
                        this.isSaved = true;
                        this.$router.push("/")
                    })
                };
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Are you sure you want to delete this asset?`,
                    text: 'This is a permanent and irreversible action.',
                    accept: deleteAsset
                })
            },
            updateAsset() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.isLoading = true;
                        this.$root.addLoading('#save-asset-btn');


                        let id = this.$route.params.id;
                        let url = '/assets';
                        if (id) {
                            url += '/' + id;
                        }
                        let data = this.asset;
                        if (!data.price) {
                            data.price = 0;
                        }
                        this.$axios({
                            method: id ? 'put' : 'post',
                            url: url,
                            data: Object.assign({}, data, {academic_metadata: []})
                        }).then(res => {
                            Promise.all(this.asset.academic_metadata.map(m => this.$axios({
                                method: m.new ? "POST" : "PUT",
                                url: "/academic-metadata/" + (m.new ? "" : m._id),
                                data: Object.assign(m, {asset: res.data._id})
                            }))).then(() => {
                                this.$root.removeLoading('#save-asset-btn');
                                this.isLoading = false;
                                this.$vs.notifyWrapper({
                                    color: 'success',
                                    fixed: true,
                                    title: id ? 'Updated Successfully' : 'Successfully created'
                                })
                                this.isSaved = true;
                                this.$router.push(`/${res.data._id}`)

                            });
                        }).catch((error) => {
                            console.log(error);
                            this.isLoading = false;
                            this.$root.removeLoading('#save-asset-btn')
                        })
                    } else {
                        this.$vs.notifyWrapper({
                            color: 'danger',
                            fixed: true,
                            title: 'Validation error',
                            text: 'Fill all fields'
                        })
                    }
                })
            },
            successThumbnailUpload(event) {
                let res = JSON.parse(event.target.response);
                this.asset.thumbnail = [];
                this.asset.thumbnail.push(res[0].id);
                this.thumbnails = [];
                this.thumbnails.push(res[0]);

                this.$refs.thumbnail.filesx.forEach((item, index) => {
                    this.$refs.thumbnail.removeFile(index);
                })

                this.$root.removeLoading('#edit-asset-update-btn');

                this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Upload Successful'})
            },
            deleteThumbnailUpload(event) {

            },
            errorThumbnailUpload(event) {
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Upload failed'})
            },
            deleteImage() {
                this.thumbnails = [];
            },
            editMetadata(item) {
                this.editMetadataItem = item;
                this.isAddMetaData = true;
            },
            getTypeName(item) {
                if (!item.asset_type) return "";
                return this.$store.state.assetTypes[item.asset_type] || "";
            },
            getDateFormat(date) {
                let d = new Date(date);
                let dateString = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " +
                    d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();

                return dateString;
            },
            formatBytes(files, decimals = 2) {
                let bytes = 0;
                if (!files || !files.length) return '0 KB';

                files.forEach(item => {
                    bytes += item.size;
                })

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));
                if (i === -1) {
                    return bytes + ' ' + sizes[0];
                }

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
        },
    }
</script>
